module.exports = __webpack_public_path__ + "img/logo-vr.a4e5306e.png";